// Si la URL base termina en "/", se quita para no duplicarla.
const BASE_URL = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");

export const ApiRequestInterceptor = async (path, method, body, header = {}) => {
  try {
    const params = ApiRequestParamsFormatter(method, body, header);
    const response = await fetch(`${BASE_URL}/${path}`, params);
    return ApiRequestFormatter(response);
  } catch (exception) {
    //TODO Handle Exception Pendient
    return {
      error: 500,
      data: null,
    };
  } finally {
    //TODO Handle Loading
  }
};

const ApiRequestParamsFormatter = (method, body, header) => {
  const headers = ApiRequestHeaderFormatter(header);

  return method !== "GET" && body
    ? {
      method,
      body: JSON.stringify(body),
      headers,
    }
    : { method, headers };
};

const ApiRequestFormatter = async (response) => {
  const code = response.status;
  let data = null;

  // Intenta leer JSON para cualquier código 2xx–4xx
  if (code >= 200 && code < 500) {
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }
  }

  return { code, data };
};

const ApiRequestHeaderFormatter = (header = {}) => {
  let headers = new Headers();

  try {
    const loginData = JSON.parse(localStorage.getItem("logindata") || "{}");
    const token = loginData?.data?.token;   // 👈 el token está dentro de data
    if (token) {
      headers.append("Authorization", `Bearer ${token}`);
    }
  } catch { }

  headers.append("Content-Type", "application/json");

  for (const key in header) {
    headers.append(key, header[key]);
  }

  return headers;
};

